// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2AA-P","select":"Header_select__22pa2","clinic":"Header_clinic__28D2p"};